import { createTheme } from '@mui/material';

export const theme = createTheme({
  components: {
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: 'gray',
          padding: 5,
          margin: 0,
          marginLeft: 5,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          backgroundColor: 'grey.100',
          '& .MuiOutlinedInput-root': {
            borderRadius: 5,
            padding: 5,
            borderColor: 'hsl(0, 0%, 80%)',
            cursor: 'pointer',
          },
          '& label.MuiInputLabel-root': {
            color: 'white',
            fontSize: '20px',
            backgroundColor: '#343a40',
            borderRadius: 5,
            padding: 5,
            left: -6,
            top: -8,
            cursor: 'pointer',
          },
          '& input[type="file"]::-webkit-file-upload-button': {
            backgroundColor: '#1976d2',
            color: '#fff',
            border: 'none',
            cursor: 'pointer',
            borderRadius: '5px',
          },
          '& input[type="file"]::-webkit-file-upload-text': {
            content: '"Drag and drop file here"',
          },
        },
      },
    },
  },
});
